import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationElastic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAnimationElastic"><Path d="M3.75 20.25C3.75 20.25 3.75 3.75 6.84372 3.75C8.90625 3.75 8.90619 10.9688 11.4843 10.9688C14.0625 10.9688 15.0937 6.60313 20.25 8.15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAnimationElastic;
